<bic-popup (close)="close()" [hasBackdrop]="true"
           [title]="pending ? 'Verbindung abbrechen?' : 'Verbindung zu SharePoint trennen?'" customClass="w-[560px] h-fit">
  <div bicPopupContent class="flex flex-col gap-3">
    @if (pending) {
      <span class="text-sm text-gray-900">Der offene Zustimmungslink wird ungültig. Du kannst SharePoint später erneut verbinden.</span>
    } @else {
      <span class="text-sm text-gray-900">
        @if (siteCount) {
          Die Freigaben auf {{ siteCount }} {{ siteCount === 1 ? 'Site werden' : 'Sites werden' }} entfernt; dafür meldet sich
          ein SharePoint-Admin noch einmal bei Microsoft an. Verknüpfte Ordner werden danach nicht mehr synchronisiert,
          bereits übernommene Dateien bleiben in planBIC erhalten.
        } @else {
          Es sind keine Sites freigegeben. Die Verbindung wird sofort getrennt.
        }
      </span>
      <span class="text-sm text-gray-500">
        Die App „planBIC Connector“ bleibt im Microsoft-Tenant eingetragen, bis eure IT sie unter
        Unternehmensanwendungen entfernt.
      </span>
    }
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
    <bic-button buttonType="white" (onClick)="close()">Abbrechen</bic-button>
    <bic-button buttonType="red" [loading]="busy" [disabled]="busy" (onClick)="disconnect()">
      {{ pending ? 'Verbindung abbrechen' : 'Verbindung trennen' }}
    </bic-button>
  </div>
</bic-popup>
